<template>
  <ModalConfirmation labelYes="OK"
                     labelNo="Cancel"
                     minWidthYesButton="80px"
                     minWidthNoButton="80px"
                     v-bind="modalAttrs"
                     :name="modalName"
                     :text="text"
                     @before-open="beforeModalOpen"
                     @yes="deleteTenantTeamTenantUser"
                     @no="cancel" />
</template>

<script>
  import ModalConfirmation from '@modals/modal-confirmation'
  import { MODAL_WINDOW_NAMES } from '@js/constants'

  export default {
    name: 'ModalDeleteTenantTeamTenantUser',
    components: {
      ModalConfirmation,
    },
    data: function () {
      return {
        modalAttrs: {},
        modalName: MODAL_WINDOW_NAMES.DELETE_TENANT_TEAM_TENANT_USER_PRIMARY,
        tenantTeamTenantUser: null,
      };
    },
    computed: {
      tenantTeamName: function () {
        return this.tenantTeamTenantUser ? (this.tenantTeamTenantUser.tenantTeam ? this.tenantTeamTenantUser.tenantTeam.name : '') : '';
      },
      userName: function () {
        const user = this.tenantTeamTenantUser ? (this.tenantTeamTenantUser.tenantUser ? this.tenantTeamTenantUser.tenantUser.user : null) : null;
        return user ? `${user.firstName} ${user.lastName}` : '';
      },
      text: function () {
        return `Are you sure you delete ${this.userName} from ${this.tenantTeamName}?`;
      },
    },
    methods: {
      beforeModalOpen: function (e) {
        this.tenantTeamTenantUser = e.params ? (e.params.tenantTeamTenantUser ? e.params.tenantTeamTenantUser : null) : null;
      },
      cancel: function () {
        this.close();
      },
      clear: function () {
        this.tenantTeamTenantUser = null;
      },
      close: function () {
        this.clear();
        this.$modal.hide(this.modalName);
      },
      deleteTenantTeamTenantUser: function () {
        this.$emit('delete-tenant-team-tenant-user', this.tenantTeamTenantUser);
      },
    },
  };
</script>
